interface Props {
  title: string
  name: string
  onClick: (value: number) => void
}
export const SchoolSurveyRadios: React.FC<Props> = ({
  title,
  name,
  onClick,
}) => {
  return (
    <>
      <div className="mb-[10px] text-base font-normal tracking-normal leading-6 text-center text-[#316ab0]">
        {title}
      </div>
      <div className="flex justify-center mb-[35px]">
        <p className="pt-6 mb-0 tracking-normal text-[#aaa] opacity-100">
          できない
        </p>
        <form className="inline-flex">
          {Array(5)
            .fill(0)
            .map((_, i) => (
              <div
                key={`${name}-${i + 1}`}
                className={'relative mx-[10px] w-5 h-11'}
              >
                <div className="text-center">{i + 1}</div>
                <input
                  className="p-0 m-0 w-5 h-5 leading-4 opacity-100"
                  type="radio"
                  name={name}
                  value={i + 1}
                  onClick={(e) => onClick(+e.currentTarget.value)}
                />
              </div>
            ))}
        </form>
        <p className="pt-6 mb-0 tracking-normal text-[#aaa] opacity-100">
          できた
        </p>
      </div>
    </>
  )
}
